export default "__VITE_ASSET__QivJUp52__"